// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./components-wpbbsa/wpbbsa-calculator-item-v2/wpbbsa-calculator-item-v2.component.scss
// module id = 1008
// module chunks = 0